import * as React from "react";
import { FormHelperText, Tab, Tabs } from "@mui/material";
import { RadioButtonProps } from "./types";

import TypographyContainer from "../../layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../layout/page/typography-container/typography-item-container";
import CustomTypography from "../typography";
import "./styles.scss";

const classNameBase = "scd-radiobutton";

export default function RadioButton<T>({
  id,
  title,
  helper,
  subTitle,
  values,
  selectedValue,
  error,
  disabled,
  errorText,
  descriptionText,
  wrap = true,
  fullStretch,
  fullWidth,
  onChange,
  onClick,
  onBlur,
}: RadioButtonProps<T>): React.JSX.Element {
  const stringValues = values.map((v) => v.value);
  let selectedValueIndex: boolean | number =
    stringValues.indexOf(selectedValue);

  // -1 when there is nothing selected. Set to false for material-ui.
  if (selectedValueIndex === -1) {
    selectedValueIndex = false;
  }

  const classNameTabs =
    `${wrap ? "" : `${classNameBase}-wrap`}` +
    `${fullStretch ? `${classNameBase}-stretch` : ""}` +
    `${fullWidth ? `${classNameBase}-full-width` : ""}`;

  const classNameRadioButtonContainer =
    `${classNameBase}-container` +
    `${error ? ` ${classNameBase}-container-error` : ""}` +
    `${disabled ? ` ${classNameBase}-container-disabled` : ""}` +
    `${selectedValue ? ` ${classNameBase}-container-selected` : ""}`;

  return (
    <>
      <div className={classNameRadioButtonContainer}>
        <FormHelperText component="div" className={`${classNameBase}-label`}>
          {title}
        </FormHelperText>
        {helper && (
          <FormHelperText className={`${classNameBase}-helper`}>
            {helper}
          </FormHelperText>
        )}

        {subTitle && (
          <TypographyContainer>
            <TypographyItemContainer>
              <CustomTypography variant="body1" component="div">
                {subTitle}
              </CustomTypography>
            </TypographyItemContainer>
          </TypographyContainer>
        )}
        <Tabs
          id={id}
          classes={{
            root: `${classNameBase}-wrapper`,
            flexContainer: `${classNameBase}-flex-container`,
            scroller: `${classNameBase}-scroller`,
            scrollButtons: `${classNameBase}-scroll-buttons`,
            indicator: `${classNameBase}-indicator`,
          }}
          className={classNameTabs}
          value={selectedValueIndex}
          scrollButtons={false}
          indicatorColor="primary"
          textColor="primary"
          onChange={onChange}
          onBlur={onBlur}
          variant="fullWidth"
        >
          {values &&
            values.map((val) => (
              <Tab
                key={String(val.value)}
                id={val.id}
                label={val.label}
                onClick={() => onClick && onClick(val)}
                tabIndex={0}
                icon={
                  val.icon && (
                    <i className={`${classNameBase}-icon`}>
                      <img src={`${val.icon}`} alt="" />
                    </i>
                  )
                }
                disabled={disabled}
                className={`${classNameBase}-button-container`}
                classes={{
                  root: `${classNameBase}-button-wrapper`,
                  labelIcon: `${classNameBase}-button-label-icon`,
                  selected: `${classNameBase}-button-selected`,
                  disabled: `${classNameBase}-button-disabled`,
                  iconWrapper: `${classNameBase}-button-text`,
                }}
              />
            ))}
        </Tabs>
        {descriptionText && !error ? (
          <FormHelperText className={`${classNameBase}-description`}>
            {descriptionText}
          </FormHelperText>
        ) : null}
        {error && errorText && (
          <FormHelperText
            error
            className={`${classNameBase}-description-error`}
          >
            {errorText}
          </FormHelperText>
        )}
      </div>
    </>
  );
}
